import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Dashboard } from './pages/Dashboard';
import { MedicalGlossary } from './pages/MedicalGlossary';
import { HealthMetrics } from './pages/HealthMetrics';
import { ImagingInterpreter } from './pages/ImagingInterpreter';
import { LabInterpreter } from './pages/LabInterpreter';
import { OfficeVisitInterpreter } from './pages/OfficeVisitInterpreter';
import { HealthQuestions } from './pages/HealthQuestions';
import { SymptomTracker } from './pages/SymptomTracker';
import { ExerciseTracker } from './pages/ExerciseTracker';
import { MedicationInfo } from './pages/MedicationInfo';
import { HealthRecords } from './pages/HealthRecords';
import { AIAdvisor } from './pages/AIAdvisor';
import { InsuranceGuide } from './pages/InsuranceGuide';
import { MainLayout } from './components/layout/MainLayout';
import { useThemeStore } from './store/themeStore';

// Theme manager component that respects landing page light theme requirement
function ThemeManager() {
  const theme = useThemeStore((state) => state.theme);
  const location = useLocation();

  React.useEffect(() => {
    const isLandingPage = location.pathname === '/' || location.pathname === '/login';

    if (isLandingPage) {
      document.documentElement.classList.remove('dark');
    } else if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme, location.pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ThemeManager />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LandingPage />} />

        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          {/* Health feature routes - all point to Dashboard for now as skeleton */}
          <Route path="/health-questions" element={<HealthQuestions />} />
          <Route path="/symptom-tracker" element={<SymptomTracker />} />
          <Route path="/health-metrics" element={<HealthMetrics />} />
          <Route path="/health-records" element={<HealthRecords />} />
          <Route path="/exercise-tracker" element={<ExerciseTracker />} />
          <Route path="/lab-results" element={<LabInterpreter />} />
          <Route path="/imaging-reports" element={<ImagingInterpreter />} />
          <Route path="/visit-notes" element={<OfficeVisitInterpreter />} />
          <Route path="/medication-info" element={<MedicationInfo />} />
          <Route path="/interaction-checker" element={<MedicationInfo />} />
          <Route path="/my-medications" element={<MedicationInfo />} />
          <Route path="/medical-glossary" element={<MedicalGlossary />} />
          <Route path="/insurance-guide" element={<InsuranceGuide />} />
          <Route path="/ai-advisor" element={<AIAdvisor />} />
          <Route path="/profile" element={<Dashboard />} />
          <Route path="/billing" element={<Dashboard />} />
          <Route path="/activity/:id" element={<Dashboard />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
